import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import CategoryIcon from "@mui/icons-material/Category";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import api from "../../api/api";
import AddIcon from "@mui/icons-material/Add";

import { red, blue, green, purple } from "@mui/material/colors";
// MUI
import {
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  preferedlanguage_change,
  usertype_change,
  category_change,
  assessment_change,
} from "./TeacherBaseline.Slice";
import {
  getcategoryThunk,
  getTeacherAssessmentThunk,
  createTeacherAssessmentThunk,
  updateTeacherAssessmentThunk,
  deleteTeacherAssessmentThunk,
} from "./TeacherBaseline.Thunk";

const TeacherBaselinePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // -------------- Card-item vertical menu ---------------

  const [anchorEl, setAnchorEl] = useState(null);

  const handleVertMenuClose = () => {
    setAnchorEl(null);
  };
  // ---------------------------------------------

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------

  // ---------------- navigate to category page -------------
  const navigate_to = () => {
    navigate("/teachercategory");
  };
  // ------------------------------------------------------------

  // --------- options for dropdowns ---------
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];

  const usertype_select_option_list = [
    { value: "fellow", text: "Fellow" },
    { value: "anganwadi", text: "Anganwadi" },
    { value: "school", text: "School" },
  ];
  const assessment_select_option_list = [
    { value: "baseline", text: "Baseline" },
    { value: "endline", text: "Endline" },
  ];
  // ---------------------------------------------
  const categoryId = useSelector(
    (state) => state.TeacherBaselineSlice.categoryId.categoryId
  );
  // ------------ dropdowns on change ----------------
  const preflanguage_select_onchange = (event) => {
    dispatch(preferedlanguage_change(event.target.value));
  };
  const usertype_select_onchange = (event) => {
    dispatch(usertype_change(event.target.value));
  };
  const category_select_onchange = (event, value) => {
    dispatch(
      category_change(
        { categoryId: event.target.value, categoryName: value.props.children }

        // categoryName: value.props.children,
      )
    );
  };
  const assessment_select_onchange = (event) => {
    dispatch(assessment_change(event.target.value));
  };
  // -------------------------------------------------

  // ------------ Load data & skill ----------------
  const data = useSelector((state) => state.TeacherBaselineSlice.data);

  const _id = data.length > 0 ? data[0]["_id"] : "";

  const existing_segments = data.length > 0 ? data : [];

  const category_select_option_list = useSelector(
    (state) => state.TeacherBaselineSlice.category
  );

  const language = useSelector(
    (state) => state.TeacherBaselineSlice.preferedlanguage
  );
  const usertype = useSelector((state) => state.TeacherBaselineSlice.usertype);

  const categoryName = useSelector(
    (state) => state.TeacherBaselineSlice.categoryName
  );

  const type = useSelector((state) => state.TeacherBaselineSlice.type);

  useEffect(() => {
    const load_category_list = () => {
      dispatch(getcategoryThunk(usertype));
    };

    const load_data = () => {
      const params = { usertype, categoryId, type };

      dispatch(getTeacherAssessmentThunk(params));
    };

    load_category_list();
    load_data();
  }, [dispatch, usertype, language, type, categoryId, categoryName]);

  // -----------------------------------------------

  // For State Declaration
  const [show, setShow] = useState(false);

  //On Modal close and open

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [changeA, setChangeA] = useState("");
  const handleChangeA = (event) => {
    setChangeA(event.target.value);
  };
  const [changeB, setChangeB] = useState("");
  const handleChangeB = (event) => {
    setChangeB(event.target.value);
  };
  const [changeC, setChangeC] = useState("");
  const handleChangeC = (event) => {
    setChangeC(event.target.value);
  };
  const [changeD, setChangeD] = useState("");

  const handleChangeD = (event) => {
    setChangeD(event.target.value);
  };
  const [changeAns, setChangeAns] = useState("");

  const handleChangeAns = (event) => {
    setChangeAns(event.target.value);
  };

  const [changeQuestion, setChangeQuestion] = useState("");
  const handleChangeQuestion = (event) => {
    setChangeQuestion(event.target.value);
  };

  const [isLoading, setIsLoading] = useState(false);
  const dataa = {
    qid: new Date().getTime(),
    question: changeQuestion,
    A: changeA,
    B: changeB,
    C: changeC,
    D: changeD,
    answer: changeAns,
    language: "od",
    usertype: usertype,
    type: type,
    category: categoryId,
  };
  const params = { usertype, categoryId, type };

  const handleSave = () => {
    setShow(false);
    setIsLoading(true);
    toast.success("Changes made successfully");
    dispatch(createTeacherAssessmentThunk(dataa)).then((res) => {
      const params = { usertype, categoryId, type };
      dispatch(getTeacherAssessmentThunk(params));
      
    });
  };

  const handleUpdateChanges = () => {
    api.put(`updateteacherassessment/${updateData._id}`, updateData).then(
      (response) => {
        // setResult(response.data);
        if (response.data.status === "success") {
          toast.success("Changes made successfully");
         
          const params = { categoryId, usertype, type };
          dispatch(getTeacherAssessmentThunk(params));
         
        }
      },
      (err) => {
        //console.log(err);
        toast.error("Enter a valid Quiz");
      }
    );

    setShowUpdate(false);
  };
  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };

  const handleShowUpdate = (eachskill) => {
    setUpdateData({
      A: eachskill.A,
      B: eachskill.B,
      C: eachskill.C,
      D: eachskill.D,
      answer: eachskill.answer,
      qid: new Date().getTime(),
      question: eachskill.question,
      questiontype: eachskill.questiontype,
      _id: eachskill._id,
    });

    setShowUpdate(true);
  };

  const [showUpdate, setShowUpdate] = useState(false);
  const [updateData, setUpdateData] = useState({
    A: "",
    B: "",
    C: "",
    D: "",
    answer: "",
    qid: new Date().getTime(),
    question: "",
    questiontype: "",
    _id: "",
    usertype: usertype,
    type: type,
    category: categoryId,
    language: "od",
  });

  const delete_content_button_click = (eachskill) => {
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteTeacherAssessmentThunk(eachskill._id)).then((res) => {
          const params = { categoryId, usertype, type };
          dispatch(getTeacherAssessmentThunk(params));
          toast.success("Changes made successfully");
        });
      }
    });
  };

  return (
    <>
      <div>
        <MuiHeader header="Teacher Assessment" />

        <FormControl sx={{ m: 1, width: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Language</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={language}
            label="Language"
            onChange={preflanguage_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {language_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, width: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype}
            label="Usertype"
            onChange={usertype_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, width: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Category</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={categoryId}
            label="Category"
            onChange={category_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {category_select_option_list.map((option) => (
              <MenuItem key={option.categoryId} value={option.categoryName}>
                {option.categoryName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, width: 140, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Assessment</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={type}
            label="Assessment"
            onChange={assessment_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {assessment_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div>
        <Button
          onClick={navigate_to}
          variant="outlined"
          sx={{ m: 1, marginTop: -5, backgroundColor: "blue", height: "38px" }}
          size="small">
          <CategoryIcon
            style={{
              color: "orange",
              marginTop: "-3px",
            }}></CategoryIcon>
          <b style={{ color: "black" }}>Category</b>
        </Button>
      </div>

      {/* Show List */}
      <div>
        <div>
          <Button
            onClick={handleShow}
            variant="contained"
            sx={{ marginTop: 3, float: "left" }}>
            create
            <AddIcon />
          </Button>
          <br />
          <br />
          <br />

          <Modal
            open={show}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box sx={style}>
              <br />
              <FormControl sx={{ m: 1 }} size="small">
                <TextField
                // style={{ width: "300px",wordBreak: "break-all"}}
                  id="filled-basic"
                  label="Question"
                  variant="filled"
                  onChange={handleChangeQuestion}
                />
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2} style={{ marginTop: 12 }}>
                    <Grid item xs={6} md={6}>
                      <TextField
                      //  style={{wordBreak: "break-all", width: "150px"}}
                        id="outlined-basic"
                        label="Option A"
                        variant="outlined"
                        onChange={handleChangeA}
                      />
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <TextField
                      //  style={{wordBreak: "break-all", width: "150px"}}
                        id="outlined-basic"
                        label="Option B"
                        variant="outlined"
                        onChange={handleChangeB}
                      />
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <TextField
                      //  style={{wordBreak: "break-all", width: "150px"}}
                        id="outlined-basic"
                        label="Option C"
                        variant="outlined"
                        onChange={handleChangeC}
                      />
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <TextField
                      //  style={{wordBreak: "break-all", width: "150px"}}
                        id="outlined-basic"
                        label="Option D"
                        variant="outlined"
                        onChange={handleChangeD}
                      />
                    </Grid>
                  </Grid>

                  <FormControl sx={{ m: 2, minWidth: 300 }} size="small">
                    <InputLabel id="demo-select-small">Ans:</InputLabel>
                    <Select
                      labelId="demo-select-small"
                      id="demo-select-small"
                      label="Ans"
                      onChange={handleChangeAns}>
                      <MenuItem value="">
                        <em>Select Answer</em>
                      </MenuItem>

                      <MenuItem value="A">A</MenuItem>
                      <MenuItem value="B">B</MenuItem>
                      <MenuItem value="C">C</MenuItem>
                      <MenuItem value="D">D</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </FormControl>

              <Button
                variant="outlined"
                style={{ marginLeft: 12 }}
                onClick={handleClose}>
                Close
              </Button>
              <Button variant="contained" onClick={handleSave}>
                Save
              </Button>
            </Box>
          </Modal>
        </div>
        <table style={{ border: "1px solid blue", marginTop: "0px" }}>
          {existing_segments.map((eachskill, index) => (
            <thead>
              <tr>
                <th
                  style={{
                    width: "700px",
                    textAlign: "left",
                    wordBreak: "break-all"
                  }}>
                  {" "}
                  {index + 1}.{eachskill.question}
                </th>
                <th>
                  <Button
                    variant="contained"
                    onClick={() => delete_content_button_click(eachskill)}
                    sx={{ marginLeft: 30 }}>
                    Delete
                  </Button>
                </th>
                <th>
                  <Button
                    variant="contained"
                    onClick={() => handleShowUpdate(eachskill)}>
                    Update
                  </Button>
                </th>
              </tr>
              <tbody>
                <tr>
                  <td style={{ width: "350px" , wordBreak: "break-all"}}>A.{eachskill.A}</td>
                  <td style={{ width: "350px" , wordBreak: "break-all"}}>B.{eachskill.B}</td>
                </tr>
                <tr>
                  <td style={{ width: "350px" , wordBreak: "break-all"}}>C.{eachskill.C}</td>
                  <td style={{ width: "350px" , wordBreak: "break-all"}}>D.{eachskill.D}</td>
                </tr>
                <tr>
                  <td>Answer.{eachskill.answer}</td>
                </tr>
              </tbody>
            </thead>
          ))}
        </table>
        <Modal
          open={showUpdate}
          onClose={handleCloseUpdate}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description">
          <Box sx={style}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
              <TextField
                id="filled-basic"
                label="Objective Question"
                variant="filled"
                value={updateData.question}
                onChange={(e) =>
                  setUpdateData({
                    ...updateData,
                    question: e.target.value,
                  })
                }
              />

              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2} style={{ marginTop: 12 }}>
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Option A"
                      variant="outlined"
                      value={updateData.A}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          A: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Option B"
                      variant="outlined"
                      value={updateData.B}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          B: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Option C"
                      variant="outlined"
                      value={updateData.C}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          C: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Option D"
                      variant="outlined"
                      value={updateData.D}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          D: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>

                <FormControl sx={{ m: 2, minWidth: 300 }} size="small">
                  <InputLabel id="demo-select-small">Ans:</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    label="Ans"
                    value={updateData.answer}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        answer: e.target.value,
                      })
                    }>
                    <MenuItem value="">
                      <em>Select Answer</em>
                    </MenuItem>

                    <MenuItem value="A">A</MenuItem>
                    <MenuItem value="B">B</MenuItem>
                    <MenuItem value="C">C</MenuItem>
                    <MenuItem value="D">D</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </FormControl>

            <Button
              variant="outlined"
              style={{ marginLeft: 12 }}
              onClick={handleCloseUpdate}>
              Close
            </Button>
            <Button variant="contained" onClick={handleUpdateChanges}>
              Update
            </Button>
          </Box>
        </Modal>
      </div>
      {/* Toaster */}
      <ToastContainer />
    </>
  );
};

export default TeacherBaselinePage;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
